function queryfilter_parse_filters(classSelector = 'queryloop-filter') {
	let selectedPairs = {};
	let selectedIDPairs = {};
	let target;
	let type;
	let selectedValue;
	let selectedID;
	let paged = 1;
	jQuery('.' + classSelector).each(function () {
		let taxonomyName = jQuery(this).data('taxonomy-name');
		target = jQuery(this).data("target");
		type = jQuery(this).data("type");
		
		if (jQuery(this).is('select')) {
			selectedValue = jQuery(this).val();
			selectedID = [jQuery(this).find('option:selected').data('termid')];
			if (selectedValue === '') {
				queryfilter_removeParameter(taxonomyName);
			}
		} else if (jQuery(this).is(':checkbox')) {
			let selectedCheckboxes = jQuery('.' + classSelector + '[data-taxonomy-name="' + taxonomyName + '"]:checked');
			let selectedCheckboxValues = selectedCheckboxes.map(function () {
				return jQuery(this).val();
			}).get();
			let selectedCheckboxIDs = selectedCheckboxes.map(function () {
				return jQuery(this).data('termid');
			}).get();
			if (selectedCheckboxValues.length > 0) {
				selectedValue = selectedCheckboxValues;
				selectedID = selectedCheckboxIDs;
			} else {
				queryfilter_removeParameter(taxonomyName);
			}
		} else if (jQuery(this).is(':radio')) {
			let selectedRadio = jQuery('.' + classSelector + '[data-taxonomy-name="' + taxonomyName + '"]:checked');
			selectedValue = selectedRadio.val();
			selectedID = [selectedRadio.data('termid')];
		} else if (jQuery(this).is('input[type="text"]')) {
			selectedValue = jQuery(this).val();
			if (selectedValue === '') {
				queryfilter_removeParameter(taxonomyName);
			}
		}
		
		if (type === 'meta' || type === 'taxonomy') {
			if (!selectedPairs[type]) {
				selectedPairs[type] = {};  // Initialize as an empty object if it's not already
			}
			if (!selectedIDPairs[type]) {
				selectedIDPairs[type] = {};  // Initialize as an empty object if it's not already
			}
			if (selectedValue !== undefined && selectedValue !== '') {
				selectedPairs[type][taxonomyName] = selectedValue;
				selectedIDPairs[type][taxonomyName] = selectedID;
			}
		} else {
			if (taxonomyName && typeof selectedValue !== "undefined") {
				let tempPairs = {};
				tempPairs[taxonomyName] = selectedValue;
				queryfilter_updateURL(tempPairs);
				jQuery(target).data(type, selectedValue);
			}
		}
	});

	let selectedPairsJSON = JSON.stringify(selectedPairs);
	let selectedIDPairsJSON = JSON.stringify(selectedIDPairs);

	for (let key in selectedPairs) {
		if (jQuery.isEmptyObject(selectedPairs[key])) {
			jQuery(target).removeData(key);
		} else {
			jQuery(target).data(key, selectedIDPairs[key]);
		}
		queryfilter_updateURL(selectedPairs[key]);
	}

	jQuery(target).data('paged', paged);
	jQuery(target).data('reset', "1");
	jQuery(target).trigger('queryloop_loadmore');
}

function queryfilter_removeParameter(parameterName) {
	let currentURL = new URL(window.location.href);
	let searchParams = currentURL.searchParams;
	searchParams.delete(parameterName);
	let newURL = currentURL.origin + currentURL.pathname + '?' + searchParams.toString();
	window.history.pushState({}, '', newURL);
}

function queryfilter_updateURL(selectedPairs) {
	let currentURL = new URL(window.location.href);
	let searchParams = currentURL.searchParams;
	for (let key in selectedPairs) {
		searchParams.delete(key);
	}
	let keysWithMultipleValues = {};
	for (let key in selectedPairs) {
		if (Array.isArray(selectedPairs[key])) {
			keysWithMultipleValues[key] = selectedPairs[key];
		} else {
			searchParams.set(key, selectedPairs[key]);
		}
	}
	for (let key in keysWithMultipleValues) {
		searchParams.set(key, keysWithMultipleValues[key]);
	}
	for (let [key, value] of searchParams.entries()) {
		if (!value) {
			searchParams.delete(key);
		}
	}
	let newURL = currentURL.origin + currentURL.pathname + '?' + searchParams.toString();
	window.history.pushState({}, '', newURL);
}

function queryfilter_reset_filters() {
	jQuery('.queryloop-filter').each(function () {
		if (jQuery(this).is('select')) {
			jQuery(this).val('');
		} else if (jQuery(this).is(':checkbox')) {
			jQuery(this).prop('checked', false);
		} else if (jQuery(this).is(':radio')) {
			jQuery(this).prop('checked', false);
			let taxonomyName = jQuery(this).data('taxonomy-name');
			queryfilter_removeParameter(taxonomyName);
		} else if (jQuery(this).is('input[type="text"]')) {
			jQuery(this).val(''); // Clear the text field value
			let taxonomyName = jQuery(this).data('taxonomy-name');
		}
	});
	queryfilter_parse_filters();
}

jQuery(document).ready(function () {
	jQuery('.queryloop-filter').on('change', function () {
		if (jQuery(this).hasClass('queryloop-filter--search')) {
			return
		}
		queryfilter_parse_filters();
	});
	jQuery('#filterSearchButton').on('click', function () {
		queryfilter_parse_filters();
	});
	jQuery('#filterResetButton').on('click', function () {
		queryfilter_reset_filters();
	});

	let typingTimer;
	const doneTypingInterval = 1000;
	jQuery('.queryloop-filter--search').keyup(function() {
		clearTimeout(typingTimer);
		if (event.which === 13) {
			queryfilter_parse_filters();
		} else {
			typingTimer = setTimeout(queryfilter_parse_filters, doneTypingInterval);
		}
	});
});
